module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "swiperCarousel",
    staticClass: "swiper-carousel",
    style: ({
      height: _vm.swiperCarouselHeight + 24 + 5 + 'px'
    })
  }, [(_vm.swiperSlides.length === 0) ? _c('div', {
    staticClass: "swiper-carousel__loading-container",
    style: ({
      height: _vm.swiperCarouselHeight + 'px'
    })
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "44",
      "height": "12",
      "viewBox": "0 0 44 12"
    }
  }, [_c('circle', {
    staticClass: "dot dot-1",
    attrs: {
      "cx": "6",
      "cy": "6",
      "r": "6"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "dot dot-2",
    attrs: {
      "cx": "22",
      "cy": "6",
      "r": "6"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "dot dot-3",
    attrs: {
      "cx": "38",
      "cy": "6",
      "r": "6"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.swiperSlides.length !== 0) ? _c('swiper', {
    attrs: {
      "options": _vm.swiperOption,
      "ark-ga-track": 'impression',
      "ark-ga-track-category": 'Carousel',
      "ark-ga-track-dimensions": _vm.getImpressionDimensionsAttribute(),
      "ark-ga-track-condition": 'arkGaPageHelpers.get({ func: \'defaultTrackCondition\' })'
    }
  }, [_vm._l((_vm.swiperSlides), function(slide) {
    return (_vm.swiperSlides) ? _c('swiper-slide', {
      key: slide.externalId
    }, [_c('div', {
      staticClass: "slide",
      on: {
        "click": function($event) {
          _vm.handleGameClick(slide)
        }
      }
    }, [_c('a', {
      staticClass: "ark-carousel-slide__link",
      attrs: {
        "href": _vm.getGameUrl(slide),
        "ark-ga-track": 'click',
        "ark-ga-track-category": 'Carousel',
        "ark-ga-track-condition": 'arkGaPageHelpers.get({ func: \'defaultTrackCondition\' })',
        "ark-ga-track-dimensions": _vm.getClickDimensionsAttribute(slide.externalId)
      }
    }, [_c('img', {
      staticClass: "slide__img",
      attrs: {
        "src": _vm.getImg(slide),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slide__footer"
    }, [_c('a', {
      staticClass: "slide__button",
      attrs: {
        "href": _vm.getGameUrl(slide)
      }
    }, [_c('span', {
      staticClass: "slide__button-text"
    }, [_vm._v(_vm._s(_vm.locale.play))]), _c('i', {
      staticClass: "triangle-right"
    })])])])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    class: ['swiper-button-prev', {
      'swiper-button-always-show': _vm.alwaysShowNav
    }],
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    class: ['swiper-button-next', {
      'swiper-button-always-show': _vm.alwaysShowNav
    }],
    slot: "button-next"
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a8c1354","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel.vue
// module id = 12
// module chunks = 0